<template>
    <li class="product">
        <div class="product__img" :style="bgImage" @click="showInfo">
            <meta v-if="product.images && product.images.large" itemprop="image" :content="product.images.large[0]" />
        </div>
        <div class="product__details" @click="showInfo">
            <h3 v-html="product.name" class="text-ellipsis"></h3>
            <div class="product__subtitle primary-lighter">
                <span v-if="product.climate_zone.naam" :title="$t('products.climate')">
                    <span class="fa">&#xf185;</span> {{ product.climate_zone.naam }}
                </span>
                <span v-if="product.form_description.naam" :title="$t('products.shape')">
                    {{ product.form_description.naam }}
                </span>
                <span v-if="product.shipping.products_per_level && product.shipping.levels_per_cc"
                    :title="$t('products.shipping_amount')">
                    <span class="fa">&#xf468;</span> {{ product.shipping.products_per_level }} &times; {{
                        product.shipping.levels_per_cc }}
                </span>
                <span v-if="product.remark" :title="$t('checkout.remarks')">
                    <span class="fa">&#xf27a;</span> {{ product.remark }}
                </span>


                <span v-if="$store.getters['Auth/isAuthenticated'] && product.available_units"
                    :title="$t('products.available_units')">
                    <span class="fa">&#xf466;</span> {{ product.available_units }}
                </span>

                <a v-if="product.manual" :href="product.manual" @click.stop :title="$t('products.manual')" target="_blank">
                    <span class="fa">&#xf15c;</span> {{ $t('products.manual') }}
                </a>
                <span class="product__size__details">{{ product.size.naam }} {{ product.pot_size.naam }}</span>
            </div>
        </div>
        <div class="product__size primary-lighter" @click="showInfo">
            {{ product.size.naam }} {{ product.pot_size.naam }}
        </div>
        <div class="product__price" @click="showInfo" v-if="typeof product.price.sale_price === 'number'">
            <template v-if="$store.getters['Auth/isAuthenticated']">
                {{ product.price.sale_price | priceformat }}
            </template>
        </div>
        <div class="product__cart" v-if="showCartForGuests || $store.getters['Auth/isAuthenticated']">
            <span class="fa">
                &#xf07a;
            </span>
            <input type="number" min="0" class="input" placeholder="0" :value="qty || undefined" @change="addToCart" />
        </div>
        <div class="product__totalprice"
            v-if="mode === 'cart' && qty && typeof product.price.sale_price === 'number' && $store.getters['Auth/isAuthenticated']">
            {{ product.price.sale_price * qty | priceformat }}
        </div>
    </li>
</template>

<script>
export default {
    name: 'Product',
    props: {
        cartMap: Object,
        data: Object,
        mode: String,
        view: String,
        showCartForGuests: Boolean,
    },
    data() {
        return {
            qty: 0,
            productInfo: false,
        };
    },
    computed: {
        currentlang() {
            return this.$store.getters['Language/current'];
        },

        bgImage() {
            if (this.product.images && this.product.images.preview) {
                return { backgroundImage: `url(${this.product.images.preview})` };
            }
            return { backgroundImage: 'url(\'/img/kingsplaceholder.png\')', backgroundSize: 'contain' };
        },

        product() {
            return (this.mode === 'products') ? this.data : this.data.product;
        },
    },
    methods: {
        addToCart(action) {
            if (typeof action === 'object') {
                this.qty = +action.target.value;
            }
            let amount = this.qty;
            if (action === 'click') {
                amount += 1;
            }
            this.$store.commit('Products/updateCart', { product: this.product, amount });
        },

        onAmountChange(val) {
            if (!val || Number.isNaN(val)) {
                this.qty = 0;
            } else {
                this.qty = val;
            }
        },

        showInfo() {
            this.$router.push({ name: 'product', params: { mode: this.mode, id: this.product.id } });
        },
    },
    watch: {
        'cartMap.amount': {
            handler: 'onAmountChange',
            immediate: true,
            deep: true,
        },
    },
};
</script>
